// localStorage 存储键
const USER_DATA_KEY = 'admin_user_data'

// 从 localStorage 恢复用户数据（刷新页面时用）
function loadUserData() {
  try {
    const raw = localStorage.getItem(USER_DATA_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

// 持久化用户数据到 localStorage
function saveUserData(data) {
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(data))
}

function clearUserData() {
  localStorage.removeItem(USER_DATA_KEY)
}

// 恢复初始 state
const persisted = loadUserData()

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: persisted?.userInfo || {},
  roleCodes: persisted?.roleCodes || [],
  permissionCodes: persisted?.permissionCodes || [],
  isSuperAdmin: persisted?.isSuperAdmin || false,
  menus: persisted?.menus || [],
  hasRoutes: false   // 动态路由是否已生成（刷新后需重新生成）
}

function persistState(state) {
  saveUserData({
    userInfo: state.userInfo,
    roleCodes: state.roleCodes,
    permissionCodes: state.permissionCodes,
    isSuperAdmin: state.isSuperAdmin,
    menus: state.menus
  })
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
    persistState(state)
  },
  SET_ROLE_CODES(state, codes) {
    state.roleCodes = codes || []
    persistState(state)
  },
  SET_PERMISSION_CODES(state, codes) {
    state.permissionCodes = codes || []
    persistState(state)
  },
  SET_IS_SUPER_ADMIN(state, val) {
    state.isSuperAdmin = !!val
    persistState(state)
  },
  SET_MENUS(state, menus) {
    state.menus = menus || []
    persistState(state)
  },
  SET_HAS_ROUTES(state, val) {
    state.hasRoutes = !!val
  },
  // 清空所有用户数据（退出登录用）
  RESET_USER(state) {
    state.token = ''
    state.userInfo = {}
    state.roleCodes = []
    state.permissionCodes = []
    state.isSuperAdmin = false
    state.menus = []
    state.hasRoutes = false
    localStorage.removeItem('token')
    clearUserData()
  }
}

// 权限管理菜单（前端硬编码，仅超管可见，后端不返回此菜单）
// 后端权限表无此记录，合并方向为单向：前端硬编码 → 追加到后端菜单树
const PERMISSION_MANAGEMENT_MENU = {
  id: '__permission_management__',
  parent_id: 0,
  name: '权限',
  code: 'access.permission',
  type: 10,
  path: '/access/permission',
  component: 'access/permission/index',
  icon: 'lock',
  sort: 999,
  status: 10,
  children: [
    {
      id: '__permission_create__',
      parent_id: '__permission_management__',
      name: '创建权限',
      code: 'access.permission.create',
      type: 20,
      path: '/access/permission/add',
      component: 'access/permission/add',
      icon: '',
      sort: 10,
      status: 10
    },
    {
      id: '__permission_update__',
      parent_id: '__permission_management__',
      name: '编辑权限',
      code: 'access.permission.update',
      type: 20,
      path: '/access/permission/edit',
      component: 'access/permission/add',
      icon: '',
      sort: 20,
      status: 10
    }
  ]
}

const actions = {
  // 一次性设置登录返回的全部用户数据
  setLoginData({ commit }, data) {
    commit('SET_TOKEN', data.token)
    commit('SET_USER_INFO', data.admin_info)
    commit('SET_ROLE_CODES', data.role_codes)
    commit('SET_PERMISSION_CODES', data.permission_codes)
    commit('SET_IS_SUPER_ADMIN', data.is_super_admin)

    // 超管：将前端硬编码的"权限管理"菜单合并到后端返回的菜单树中
    // 后端永远不会返回权限管理菜单（权限表无此记录），合并不会冲突
    let menus = data.menus || []
    if (data.is_super_admin) {
      menus = [...menus, PERMISSION_MANAGEMENT_MENU]
    }
    commit('SET_MENUS', menus)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
